// extracted by mini-css-extract-plugin
export default {"container":"BubbleExpirationPaywall_container__tE5Z3"};